import React from 'react'
import MatchInformation from './MatchInformation'
import styles from './viewMatches.module.sass'
import { ToastContainer } from 'react-toastify'


const ViewMatch = ({isChanged, setIsChanged}) => {
  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
          <div className={styles.col}>
            <MatchInformation isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
          </div>
      </div>
    </>
  )
}

export default ViewMatch